import React from 'react';
import './Footer.css';  // Importing the CSS file

function Footer() {
  return (
    <footer className="footer">
      <p className="intro-text">
        We deal in all kinds of polyurethane foam mattresses, spring mattresses, orthopedic mattresses, slab sheets, and other foam accessories. <br />
        <strong>Customization on order.</strong>
      </p>

      <div className="contact-info">
        <p><strong>Phone:</strong> +92 302 5388310</p>
        <p><strong>Email:</strong> sales@albafoam.pk</p>
      </div>

      <div className="address">
        <p><strong>Address:</strong></p>
        <p>Main Mianwali Road,</p>
        <p>Near Ahsan Petroleum, Talagang</p>
      </div>

    <strong>  <p>&copy; 2024 Alba Foam. All Rights Reserved.</p> </strong>
    </footer>
  );
}

export default Footer;
